import PropTypes from 'prop-types';
import React from 'react';
import $ from 'jquery';

function childrenToArray(children) {
    const tmp = [];
    React.Children.forEach(children, child => {
        tmp.push(child);
    });
    return tmp;
}

export default class VerticalDrawer extends React.Component {
    static displayName = 'VerticalDrawer';

    static propTypes = {
        children: PropTypes.array.isRequired,
        expandCallback: PropTypes.func.isRequired,
        selected: PropTypes.string,
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            width: null,
        };
        this.updateContainerWidth = this.updateContainerWidth.bind(this);
    }

    componentDidMount() {
        setTimeout(this.updateContainerWidth);
        $(window).on('scroll', this.updateContainerWidth);
        $(window).on('resize', this.updateContainerWidth);
    }

    componentDidUpdate(prevProps, prevState) {
        this.updateContainerWidth();
    }

    componentWillUnmount() {
        $(window).off('scroll', this.updateContainerWidth);
        $(window).off('resize', this.updateContainerWidth);
    }

    drawerRef = el => {
        this.drawer = el;
    };

    updateContainerWidth = () => {
        if (this.drawer) {
            const item = this.drawer.childNodes[0];
            const itemWidth = $(item).outerWidth(true);
            const width = $(this.drawer).innerWidth();

            if (width !== this.state.width) {
                this.setState({ itemWidth, width });
            }
        }
    };

    renderChildren() {
        const { width, itemWidth } = this.state;
        const { selected } = this.props;
        const children = childrenToArray(this.props.children);

        let ITEMS_PER_ROW;

        if (itemWidth > 0) {
            ITEMS_PER_ROW = Math.floor(width / itemWidth);
        }

        let expandKey, expandIndex;
        return children.reduce((memo, child, index) => {
            if (width == null && index > 0) {
                return memo;
            }
            const { key } = child;

            if (!key) {
                throw new Error('All children need a key for VerticalDrawer');
            }

            memo.push(
                <div className="material" key={key}>
                    {child}
                </div>
            );

            // keys seem to always get converted to strings
            if (selected && key === selected.toString()) {
                expandKey = key;
                expandIndex = index % ITEMS_PER_ROW;
            }

            const endOfRow =
                (index + 1) % ITEMS_PER_ROW === 0 ||
                index === children.length - 1;
            if (endOfRow && expandKey) {
                const itemCenter =
                    (1 + expandIndex) * itemWidth - itemWidth / 2;

                memo.push(
                    <div
                        key={`${key}-selected-arrow`}
                        className="vertial-drawer-arrow-wrapper"
                    >
                        <div
                            style={{
                                display: 'inline-block',
                                width: itemCenter - 15 + 'px',
                            }}
                        />
                        <div className="vertical-drawer-arrow" />
                    </div>
                );

                memo.push(
                    <div key={`${key}-selected`} className="vertical-drawer">
                        {this.props.expandCallback(expandKey)}
                    </div>
                );
                expandKey = null;
            }
            return memo;
        }, []);
    }

    render() {
        return (
            <div className="materials" ref={this.drawerRef}>
                {this.renderChildren()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/vertical_drawer.jsx